import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import CountUp from 'react-countup';

const Seats = ({ content }) => {
    const ticketDigits = String(
        content?.voteList?.candidateList?.[0]?.ticketCount ?? ''
    ).split('');
    const countDelay = 0;
    const countDuration = 0.6;

    return (
        <div className={styles.seats}>
            <div className={styles.seatsL}>
                <div className={styles.seatsText}>
                    <div className={styles.seatsText1}>{content?.voteList?.candidateList?.[0]?.party || ''}</div>
                    <div className={styles.seatsText2}>{content?.voteList?.candidateList?.[0]?.name}所在党派</div>
                </div>
                <img className={styles.seatsFace} src="https://x0.ifengimg.com/ucms/2026_06/46A5271468CDD9EF34360D39E23FC956DDB6F72A_size29_w126_h150.png" />
            </div>
            <div className={styles.seatsR}>
                <div className={styles.seatsRNumBox}>
                    {ticketDigits.map((digit, index) => (
                        <div
                            className={styles.seatsRNum}
                            key={`${digit}-${index}`}
                        >
                            <CountUp
                                start={0}
                                end={digit}
                                duration={countDuration}
                                delay={countDelay}
                            />
                        </div>
                    ))}
                    <div className={styles.seatsRxi}>
                        席
                    </div>
                </div>
                <div className={styles.seatsRInfo}>当前席位占比{content?.voteList?.candidateList?.[0]?.voteRate}%</div>
            </div>
        </div>
    );
};

Seats.propTypes = {
    content: PropTypes.object,
};

export default Seats;
